<template>
    <v-dialog
        v-model="showPaperworkAnalyticsPanel"
        fullscreen
        persistent
        transition="dialog-transition"
    >
        <v-toolbar dense dark color="secondary" class="white--text">
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Paperwork Analytics Panel
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon left @click="closePaperworkAnalyticsPanel">
                <v-icon>
                    mdi-window-close
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-card style="height: 80vh; background-color: #fff;">
            <v-container fluid>
                <div>
                    <v-data-iterator
                        :items="OrderToCheck"
                        :page="pageOrders"
                        :items-per-page="1"
                        hide-default-footer
                    >
                        <template v-slot:default="props">
                            <div
                                v-for="(itm, idx) in props.items"
                                :key="'ord' + idx"
                                style="height:100vh;"
                            >
                                <v-row>
                                    <v-col cols="4">
                                        <v-row
                                            style="min-height: 60vh; background-color: #fff;"
                                            class="mt-0"
                                        >
                                            <v-container grid-list-xs>
                                                <v-toolbar
                                                    dense
                                                    dark
                                                    flat
                                                    height="35"
                                                    color="secondary"
                                                    class="white--text"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-toolbar-title
                                                        style="font-size: large;"
                                                    >
                                                        BOL Quantities
                                                    </v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-simple-table
                                                    dense
                                                    max-height="200px"
                                                >
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Product
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Product Code
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    BOL Number
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Dispatched
                                                                    Quantity
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Gross
                                                                    Quantity
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Net Quantity
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="(prd,
                                                                i) in itm.eleos_data"
                                                                :key="i"
                                                            >
                                                                <td>
                                                                    {{
                                                                        prd.Product
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.ProductCode
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.BOLNumber
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.DispatchedQuantity
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.GrossQuantity
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.NetQuantity
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td
                                                                    colspan="3"
                                                                    class="text-right"
                                                                >
                                                                    <strong
                                                                        >Totals</strong
                                                                    >
                                                                </td>
                                                                <td>
                                                                    <strong>{{
                                                                        itm.TotalDQ
                                                                    }}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{
                                                                        itm.TotalGQ
                                                                    }}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{
                                                                        itm.TotalNQ
                                                                    }}</strong>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                                <v-toolbar
                                                    dense
                                                    dark
                                                    flat
                                                    height="35"
                                                    color="secondary"
                                                    class="white--text mt-2"
                                                    v-if="itm.Edit"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-toolbar-title
                                                        style="font-size: large;"
                                                    >
                                                        Corrected Quantities
                                                    </v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-simple-table
                                                    dense
                                                    max-height="200px"
                                                    v-if="itm.Edit"
                                                >
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Product
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Product Code
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    BOL Number
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Dispatched
                                                                    Quantity
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Gross
                                                                    Quantity
                                                                </th>
                                                                <th
                                                                    class="text-left"
                                                                >
                                                                    Net Quantity
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="!edit">
                                                            <tr
                                                                v-for="(prd,
                                                                i) in itm.order_details"
                                                                :key="i"
                                                            >
                                                                <td>
                                                                    {{
                                                                        prd.Product
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.ProductCode
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.BillOfLading
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.DispatchedQuantity
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.DeliveredQuantity
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.TempAdjQuantity
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td
                                                                    colspan="3"
                                                                    class="text-right"
                                                                >
                                                                    <strong
                                                                        >Totals</strong
                                                                    >
                                                                </td>
                                                                <td>
                                                                    <strong>{{
                                                                        itm.TotalDDQ
                                                                    }}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{
                                                                        itm.TotalDGQ
                                                                    }}</strong>
                                                                </td>
                                                                <td>
                                                                    <strong>{{
                                                                        itm.TotalDNQ
                                                                    }}</strong>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody v-else>
                                                            <tr
                                                                v-for="(prd,
                                                                i) in itm.order_details"
                                                                :key="i"
                                                            >
                                                                <td>
                                                                    {{
                                                                        prd.Product
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.ProductCode
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.BillOfLading
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{
                                                                        prd.DispatchedQuantity
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        dense
                                                                        hide-details
                                                                        @change="
                                                                            editBOLData
                                                                        "
                                                                        v-model="
                                                                            prd.DeliveredQuantity
                                                                        "
                                                                    ></v-text-field>
                                                                </td>
                                                                <td>
                                                                    <v-text-field
                                                                        dense
                                                                        hide-details
                                                                        @change="
                                                                            editBOLData
                                                                        "
                                                                        v-model="
                                                                            prd.TempAdjQuantity
                                                                        "
                                                                    ></v-text-field>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                                <v-row
                                                    justify="end"
                                                    v-if="edit"
                                                    style="margin-top: 0px;"
                                                >
                                                    <v-btn
                                                        color="red"
                                                        class="mr-2 mt-6"
                                                        dark
                                                        @click="cancelUpQty"
                                                        v-if="!editBOL"
                                                        >Cancel</v-btn
                                                    >
                                                    <v-btn
                                                        color="primary"
                                                        class="mt-6 mr-2"
                                                        @click="
                                                            UpdateQty(
                                                                itm.OrderID,
                                                                itm.order_details,
                                                                2
                                                            )
                                                        "
                                                        v-if="!editBOL"
                                                        >Save</v-btn
                                                    >
                                                </v-row>
                                                <v-row
                                                    justify="start"
                                                    v-if="editBOL"
                                                >
                                                    <v-col cols="4">
                                                        <v-text-field
                                                            hide-details
                                                            label="Edit BOL"
                                                            dense
                                                            v-model="bol"
                                                            @change="
                                                                editBOLData
                                                            "
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <v-btn
                                                            color="red"
                                                            class="mr-2 mt-6"
                                                            dark
                                                            @click="cancelUpQty"
                                                            >Cancel</v-btn
                                                        >
                                                        <v-btn
                                                            color="primary"
                                                            class="mt-6 mr-2"
                                                            @click="
                                                                UpdateQty(
                                                                    itm.OrderID,
                                                                    itm.order_details,
                                                                    2
                                                                )
                                                            "
                                                            >Save</v-btn
                                                        >
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        cols="4"
                                                        class="pl-4 mt-6"
                                                    >
                                                        <v-text-field
                                                            label="Delivery Date"
                                                            v-model="
                                                                itm.DateDelivered
                                                            "
                                                            dense
                                                            hide-details
                                                            @change="
                                                                updateDates(itm)
                                                            "
                                                            placeholder="YYYY-MM-DD"
                                                            v-mask="
                                                                '####-##-##'
                                                            "
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <div
                                                    style="margin: 20px 0 0 10px;"
                                                >
                                                <p style="margin: 0;"> 
                                                    <strong>Status :</strong>
                                                    {{ itm.OrderStatus }}
                                                </p>
                                                    <p style="margin: 0;">
                                                        <strong>OrderID: </strong>
                                                        {{ itm.OrderID }} 
                                                    </p>
                                                    
                                                <p style="margin: 0;"> 
                                                    <strong>LN :</strong>
                                                    {{ itm.LoadNum }}
                                                        {{
                                                            itm.LoadNumOrd > 0
                                                                ? ' - ' +
                                                                  itm.LoadNumOrd
                                                                : '- 0' 
                                                        }}
                                                </p>
                                                    <p style="margin: 0;">
                                                        <strong
                                                            >Customer:
                                                        </strong>
                                                        {{ itm.CustomerName }}
                                                    </p>
                                                    <p
                                                        style="margin: 0;"
                                                        v-if="itm.actions != []"
                                                    >
                                                        <strong
                                                            >Actions:
                                                        </strong>
                                                    </p>
                                                    <div
                                                        v-if="itm.actions != []"
                                                    >
                                                        <li
                                                            class="float-left"
                                                            v-for="(rea,
                                                            ridx) in itm.actions"
                                                            v-bind:key="
                                                                'rea' + ridx
                                                            "
                                                        >
                                                            {{ rea.Action }}
                                                        </li>
                                                    </div>
                                                    <br />
                                                    <p
                                                        style="padding: 0px;margin: 0px;"
                                                    >
                                                        <v-btn
                                                            class="float-rigth"
                                                            color="secondary"
                                                            icon
                                                            @click="
                                                                toggleView = !toggleView
                                                            "
                                                            ><v-icon
                                                                >mdi-eye-circle</v-icon
                                                            > </v-btn
                                                        >View Consignor,
                                                        Consignee, Destination
                                                    </p>
                                                    <v-simple-table
                                                        v-if="!toggleView"
                                                    >
                                                        <tr>
                                                            <th>Supplier</th>
                                                            <th>Consignor</th>
                                                            <th>Consignee</th>
                                                            <th>Destination</th>
                                                        </tr>
                                                        <tr
                                                            v-for="con in itm.Consignes"
                                                        >
                                                            <td>
                                                                {{
                                                                    con.Supplier
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    con.Consignor
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    con.Consignee
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    con.Destination
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </v-simple-table>

                                                    <v-simple-table
                                                        class="mt-5"
                                                    >
                                                        <tr>
                                                            <td class="pl-3">
                                                                <strong
                                                                    >Terminal
                                                                </strong>
                                                            </td>
                                                            <td class="pl-3">
                                                                <strong
                                                                    >Station
                                                                </strong>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                {{
                                                                    itm.Terminal
                                                                }}
                                                            </td>
                                                            <td>
                                                                {{
                                                                    itm.Station
                                                                }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pl-3">
                                                                <strong
                                                                    >Terminal
                                                                    Start</strong
                                                                >
                                                            </td>
                                                            <td class="pl-3">
                                                                <strong
                                                                    >Station
                                                                    Start</strong
                                                                >
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td class="pl-3">
                                                                <p
                                                                    v-show="
                                                                        !itm.showTStart
                                                                    "
                                                                    @click="
                                                                        showField(
                                                                            itm,
                                                                            'showTStart'
                                                                        )
                                                                    "
                                                                    :style="
                                                                        itm.TStartOrigin ==
                                                                        2
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                            : itm.TStartOrigin ==
                                                                              3
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                            : itm.TStartOrigin ==
                                                                              4
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                            : 'margin: 0 auto;padding: 2px 0 0;width: 140px;'
                                                                    "
                                                                >
                                                                    {{
                                                                        itm.TStart
                                                                    }}
                                                                    <strong
                                                                        class="timeLoadValue"
                                                                    >
                                                                        {{
                                                                            itm.TStartTime
                                                                        }}
                                                                    </strong>
                                                                </p>
                                                                <v-text-field
                                                                    v-show="
                                                                        itm.showTStart ==
                                                                            true &&
                                                                            datesOrder ==
                                                                                true
                                                                    "
                                                                    autofocus
                                                                    @blur="
                                                                        itm.showTStart = !itm.showTStart
                                                                    "
                                                                    id="TStart"
                                                                    style="
                                                                            font-size: 13px;
                                                                            padding: 0;
                                                                            margin: 0 auto;
                                                                            width: 140px;"
                                                                    placeholder="YYYY-MM-DD HH:MM"
                                                                    v-mask="
                                                                        '####-##-## ##:##'
                                                                    "
                                                                    @change="
                                                                        updateDatesOrder(
                                                                            'TStart',
                                                                            'TStartOrigin',
                                                                            itm
                                                                        )
                                                                    "
                                                                    dense
                                                                    type="tel"
                                                                    :value="
                                                                        itm.TStart +
                                                                            ' ' +
                                                                            itm.TStartTime
                                                                    "
                                                                    hide-details
                                                                >
                                                                </v-text-field>
                                                            </td>
                                                            <td class="pl-3">
                                                                <p
                                                                    v-show="
                                                                        !itm.showStStart
                                                                    "
                                                                    @click="
                                                                        showField(
                                                                            itm,
                                                                            'showStStart'
                                                                        )
                                                                    "
                                                                    :style="
                                                                        itm.StStartOrigin ==
                                                                        2
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                            : itm.StStartOrigin ==
                                                                              3
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                            : itm.StStartOrigin ==
                                                                              4
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                            : 'margin: 0 auto;padding: 2px 0 0;width: 140px;'
                                                                    "
                                                                >
                                                                    {{
                                                                        itm.StStart
                                                                    }}
                                                                    <strong
                                                                        class="timeLoadValue"
                                                                    >
                                                                        {{
                                                                            itm.StStartTime
                                                                        }}
                                                                    </strong>
                                                                </p>
                                                                <v-text-field
                                                                    v-show="
                                                                        itm.showStStart ==
                                                                            true &&
                                                                            datesOrder ==
                                                                                true
                                                                    "
                                                                    autofocus
                                                                    @blur="
                                                                        itm.showStStart = !itm.showStStart
                                                                    "
                                                                    id="StStart"
                                                                    style="
                                                                            font-size: 13px;
                                                                            padding: 0;
                                                                            margin: 0 auto;
                                                                            width: 140px;"
                                                                    placeholder="YYYY-MM-DD HH:MM"
                                                                    v-mask="
                                                                        '####-##-## ##:##'
                                                                    "
                                                                    @change="
                                                                        updateDatesOrder(
                                                                            'StStart',
                                                                            'StStartOrigin',
                                                                            itm
                                                                        )
                                                                    "
                                                                    dense
                                                                    type="tel"
                                                                    :value="
                                                                        itm.StStart +
                                                                            ' ' +
                                                                            itm.StStartTime
                                                                    "
                                                                    hide-details
                                                                >
                                                                </v-text-field>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td class="pl-3">
                                                                <strong
                                                                    >Terminal
                                                                    End</strong
                                                                >
                                                            </td>
                                                            <td class="pl-3">
                                                                <strong
                                                                    >Station
                                                                    End</strong
                                                                >
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pl-3">
                                                                <p
                                                                    v-show="
                                                                        !itm.showTEnd
                                                                    "
                                                                    @click="
                                                                        showField(
                                                                            itm,
                                                                            'showTEnd'
                                                                        )
                                                                    "
                                                                    :style="
                                                                        itm.TEndOrigin ==
                                                                        2
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                            : itm.TEndOrigin ==
                                                                              3
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                            : itm.TEndOrigin ==
                                                                              4
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                            : 'margin: 0 auto;padding: 2px 0 0;width: 140px;'
                                                                    "
                                                                >
                                                                    {{
                                                                        itm.TEnd
                                                                    }}
                                                                    <strong
                                                                        class="timeLoadValue"
                                                                    >
                                                                        {{
                                                                            itm.TEndTime
                                                                        }}
                                                                    </strong>
                                                                </p>
                                                                <v-text-field
                                                                    v-show="
                                                                        itm.showTEnd ==
                                                                            true &&
                                                                            datesOrder ==
                                                                                true
                                                                    "
                                                                    autofocus
                                                                    @blur="
                                                                        itm.showTEnd = !itm.showTEnd
                                                                    "
                                                                    id="TEnd"
                                                                    style="
                                                                            font-size: 13px;
                                                                            padding: 0;
                                                                            margin: 0 auto;
                                                                            width: 140px;"
                                                                    placeholder="YYYY-MM-DD HH:MM"
                                                                    v-mask="
                                                                        '####-##-## ##:##'
                                                                    "
                                                                    @change="
                                                                        updateDatesOrder(
                                                                            'TEnd',
                                                                            'TEndOrigin',
                                                                            itm
                                                                        )
                                                                    "
                                                                    dense
                                                                    type="tel"
                                                                    :value="
                                                                        itm.TEnd +
                                                                            ' ' +
                                                                            itm.TEndTime
                                                                    "
                                                                    hide-details
                                                                >
                                                                </v-text-field>
                                                            </td>
                                                            <td class="pl-3">
                                                                <p
                                                                    v-show="
                                                                        !itm.showStEnd
                                                                    "
                                                                    @click="
                                                                        showField(
                                                                            itm,
                                                                            'showStEnd'
                                                                        )
                                                                    "
                                                                    :style="
                                                                        itm.StEndOrigin ==
                                                                        2
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                            : itm.StEndOrigin ==
                                                                              3
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                            : itm.StEndOrigin ==
                                                                              4
                                                                            ? 'margin: 0 auto;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                            : 'margin: 0 auto;padding: 2px 0 0;width: 140px;'
                                                                    "
                                                                >
                                                                    {{
                                                                        itm.StEnd
                                                                    }}
                                                                    <strong
                                                                        class="timeLoadValue"
                                                                    >
                                                                        {{
                                                                            itm.StEndTime
                                                                        }}
                                                                    </strong>
                                                                </p>
                                                                <v-text-field
                                                                    v-show="
                                                                        itm.showStEnd ==
                                                                            true &&
                                                                            datesOrder ==
                                                                                true
                                                                    "
                                                                    autofocus
                                                                    @blur="
                                                                        itm.showStEnd = !itm.showStEnd
                                                                    "
                                                                    id="StEnd"
                                                                    style="
                                                                            font-size: 13px;
                                                                            padding: 0;
                                                                            margin: 0 auto;
                                                                            width: 140px;"
                                                                    placeholder="YYYY-MM-DD HH:MM"
                                                                    v-mask="
                                                                        '####-##-## ##:##'
                                                                    "
                                                                    @change="
                                                                        updateDatesOrder(
                                                                            'StEnd',
                                                                            'StEndOrigin',
                                                                            itm
                                                                        )
                                                                    "
                                                                    dense
                                                                    type="tel"
                                                                    :value="
                                                                        itm.StEnd +
                                                                            ' ' +
                                                                            itm.StEndTime
                                                                    "
                                                                    hide-details
                                                                >
                                                                </v-text-field>
                                                            </td>
                                                        </tr>
                                                    </v-simple-table>
                                                </div>
                                            </v-container>
                                        </v-row>
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                style="margin-top: 0px;padding-top: 0px;"
                                            >
                                                <v-toolbar
                                                    dense
                                                    dark
                                                    flat
                                                    height="35"
                                                    color="secondary"
                                                    class="white--text"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-toolbar-title
                                                        style="font-size: large;"
                                                    >
                                                        Actions
                                                    </v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                style="margin-top: 0px;padding-top: 0px;"
                                            >
                                                <div
                                                    style="display: flex;justify-content: space-around;padding-top: 20px;"
                                                >
                                                    <div>
                                                        <v-tooltip bottom>
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }"
                                                            >
                                                                <v-btn
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                    color="success"
                                                                    small
                                                                    dark
                                                                    @click="
                                                                        sendToVerifiedOrders(
                                                                            itm.OrderID,
                                                                            itm.eleos_data,
                                                                            itm.Display
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        >mdi-check-decagram-outline</v-icon
                                                                    >
                                                                </v-btn>
                                                            </template>
                                                            <span
                                                                >Send To
                                                                Verified
                                                                Orders</span
                                                            >
                                                        </v-tooltip>
                                                    </div>
                                                    <div>
                                                        <v-tooltip bottom>
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }"
                                                            >
                                                                <v-btn
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                    color="#e6b800"
                                                                    small
                                                                    dark
                                                                    @click="
                                                                        openActionReasonModal(
                                                                            itm.OrderID,
                                                                            2,
                                                                            itm.eleos_data
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        >mdi-newspaper-variant-outline</v-icon
                                                                    >
                                                                </v-btn>
                                                            </template>
                                                            <span
                                                                >Send To BOL
                                                                Cleared</span
                                                            >
                                                        </v-tooltip>
                                                    </div>
                                                    <div>
                                                        <v-tooltip bottom>
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs
                                                                }"
                                                            >
                                                                <v-btn
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                    color="error"
                                                                    small
                                                                    dark
                                                                    @click="
                                                                        openActionReasonModal(
                                                                            itm.OrderID,
                                                                            3,
                                                                            null
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        >mdi-alert-decagram-outline</v-icon
                                                                    >
                                                                </v-btn>
                                                            </template>
                                                            <span
                                                                >Send To Not
                                                                Verified
                                                                Orders</span
                                                            >
                                                        </v-tooltip>
                                                    </div>
                                                </div>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                style="margin-top: 0px;padding-top: 0px;"
                                            >
                                                <v-pagination
                                                    v-model="pageOrders"
                                                    :total-visible="7"
                                                    class="mt-6"
                                                    :length="
                                                        OrderToCheck.length
                                                    "
                                                    prev-icon="mdi-menu-left"
                                                    next-icon="mdi-menu-right"
                                                    :disabled="edit"
                                                ></v-pagination>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="8">
                                        <div
                                            style="height: 70vh; background-color: #fff;"
                                        >
                                            <v-toolbar
                                                dense
                                                dark
                                                flat
                                                height="35"
                                                color="secondary"
                                                class="white--text"
                                            >
                                                <v-spacer></v-spacer>
                                                <v-toolbar-title
                                                    style="font-size: large;"
                                                >
                                                    Document Viewer
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-data-iterator
                                                :items="itm.document"
                                                :page="page"
                                                :items-per-page="1"
                                                hide-default-footer
                                            >
                                                <template
                                                    v-slot:default="props2"
                                                >
                                                    <v-container
                                                        v-for="(it,
                                                        id) in props2.items"
                                                        :key="'document' + id"
                                                        style="background-color: #fff;"
                                                        fluid
                                                    >
                                                        <iframe
                                                            :src="
                                                                it.Link +
                                                                    '?_=$' +
                                                                    date
                                                            "
                                                            style="width: 100%; height:70vh ;"
                                                        ></iframe>
                                                        <v-pagination
                                                            v-model="page"
                                                            :length="
                                                                itm.document
                                                                    .length
                                                            "
                                                            prev-icon="mdi-menu-left"
                                                            next-icon="mdi-menu-right"
                                                        ></v-pagination>
                                                    </v-container>
                                                </template>
                                            </v-data-iterator>
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>
                    </v-data-iterator>
                </div>
            </v-container>
            <!-- <v-container v-else>
                <v-row>
                    <div style="height: 70vh;background-color: #fff;margin: 0 auto;display: flex;align-items: center;">
                        <div style="padding-right: 35px;">
                            <v-alert
                                dense
                                prominent
                                type="success"
                            >
                                <strong>No orders to review!</strong>
                            </v-alert>
                        </div>
                    </div>
                </v-row>
            </v-container> -->
        </v-card>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>

        <action
            v-if="$store.state.paperworkAnalytics.action"
            :OrderID="OrderID"
            :Actions="actions"
            :BolCheckStatus="BolCheckStatus"
            :Ord="ord"
            @closeAct="saveActions"
            @closeEdt="editModeBOL"
            @closeEdit2="editModeQty"
            @closeEdt3="editModeQtyBOL"
            @closeEdt4="postQuantitys"
        ></action>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
import action from './ActionReason.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';

export default {
    directives: { mask },
    props: [
        'OrderToCheck',
        'FromEleosCheck',
        'OrderID',
        'indexs',
        'showPaperworkAnalyticsPanel'
    ],
    components: {
        action,
        ConfirmDialogue
    },
    data: function() {
        return {
            page: 1,
            pageOrders: 1,
            order: 1,
            actions: [],
            totals: [],
            BolCheckStatus: null,
            ord: 0,
            edit: false,
            bol: null,
            editBOL: false,
            datesOrder: false,
            eleos_data: null,
            bol_posted: null,
            date: null,
            changePage: false,
            toggleView: true,
            pageIndex:0
        };
    },

    async mounted() {
        this.pageIndex = this.indexs;
        this.pageOrders = this.indexs+1;
        console.log(this.OrderToCheck, this.indexs);
        this.date = new Date().getTime();
        this.bol = null;
        this.bol_posted = null;
        this.changePage = !this.changePage;
        console.log(this.OrderToCheck[this.pageIndex], 'pageIndex')
        // await this.OrderToCheck.forEach(async x => {
        //     await x.actions.forEach(y => {
        //         if(y.Action == 'ER - Wrong BOL Number'){
        //             this.editBOL = true;
        //             this.edit = true;
        //         }
        //     });
        // });
        this.ord = this.OrderToCheck[this.pageIndex];
        this.OrderToCheck[this.pageIndex].actions.forEach( y => {
            if(y.Action == 'ER - Wrong BOL Number' && this.OrderToCheck[this.pageIndex].Edit == 0){
                this.editBOL = true;
                this.edit = true;
                this.chargeQtyEleos();
                console.log('this.ord',this.ord);
                
            }
        })
        console.log(this.editBOL)
        // await this.OrderToCheck.forEach(x => {
        //     if (x.Consignes != null) {
        //         x.Consignes = JSON.parse(x.Consignes);
        //         console.log(x.Consignes, 'Consignes');
        //     }
        // });
        await this.getHrsUpdate();
        this.searchMissingGeofance('no Save');
        // this.getActions();
    },
    watch: {
        pageOrders: function() {
            this.pageIndex =  this.pageOrders-1;
            this.date = new Date().getTime();
            this.bol = null;
            this.page = 1;
            this.bol_posted = null;
            this.getHrsUpdate();
            this.searchMissingGeofance('no Save');
            console.log('this.OrderToCheck[this.pageIndex] :',this.OrderToCheck[this.pageIndex]);
                this.OrderToCheck[this.pageIndex].actions.forEach( y => {
                    console.log(y.Action);
                    if(y.Action == 'ER - Wrong BOL Number' && this.OrderToCheck[this.pageIndex].Edit == 0){
                        this.editBOL = true;
                        this.edit = true;
                        this.chargeQtyEleos();
                    }
                })
        },
        '$store.state.paperworkAnalytics.action': function() {
            if (this.$store.state.paperworkAnalytics.action == false) {
                this.searchMissingGeofance('saveAct');
            }
        }
    },
    methods: {
        async searchMissingGeofance(saveAct) {
            //  console.log('Start',this.datesOrder,saveAct);
            // console.log('Here',this.OrderToCheck[this.pageOrders-1]);
            var search = null;
            console.log(this.OrderToCheck[this.pageOrders - 1]);
            // console.log('Size', this.OrderToCheck[this.pageOrders-1]['actions'].length);
            const saved = await this.OrderToCheck[this.pageOrders - 1][
                'actions'
            ].some(objet => 'ActionId' in objet);
            const defaulted = await this.OrderToCheck[this.pageOrders - 1][
                'actions'
            ].some(objet => 'pivot' in objet);

            var change = null;
            if (this.OrderToCheck[this.pageOrders - 1]['actions'] > []) {
                if (saved == true && defaulted == false) {
                    search = this.OrderToCheck[this.pageOrders - 1][
                        'actions'
                    ].findIndex(x => {
                        return x['ActionId'] == 21;
                    });
                    change = 1;
                    // console.log('Here1',search);
                } else if (saved == false && defaulted == true) {
                    search = this.OrderToCheck[this.pageOrders - 1][
                        'actions'
                    ].findIndex(x => {
                        return x['pivot']['ActionId'] == 21;
                    });

                    // console.log('Here2',search);
                    change = 0;
                }
            }
            //  console.log(search);
            if (search < 0 || search == null) {
                this.datesOrder = false;
            } else {
                this.datesOrder = true;
                if (change >= 1) {
                    this.$store.dispatch('setSnackbar', {
                        color: 'primary',
                        text: 'You can edit now'
                    });
                }
            }
            if (saved == true) {
                console.log(this.OrderToCheck);
                if (this.OrderToCheck.length < this.pageOrders) {
                    this.pageOrders++;
                }
            }
            //  console.log("End",this.datesOrder,saveAct);
        },
        async editModeBOL() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Correction Details',
                message: 'Would you like to make a correction?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.editBOL = true;
                this.chargeBOLEleos();
                this.chargeQtyEleos();
                this.ord.Edit = true;
                this.ord.Display = false;
            } else {
                this.saveActions();
            }
        },
        async postQuantitys() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Post Quantity',
                message: 'Would you like to make a correction?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                // this.editBOL = true;
                // this.chargeBOLEleos();
                // this.ord.Edit = true;
                console.log('Posted');
                this.ord.Display = false;
                if (this.eleos_data[0]['BOLNumber'] != undefined) {
                    this.bol_posted = this.eleos_data[0]['BOLNumber'];
                }
                this.UpdatePosted4(this.OrderID, this.eleos_data, 1);
            } else {
                this.saveActions();
            }
        },
        async editModeQty() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Correction Details',
                message: 'Would you like to make a correction?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                // this.editBOL = true;
                this.ord.Display = false;
                this.edit = true;
                this.ord.Edit = true;
                this.bol_posted = this.eleos_data[0]['BOLNumber'];
                this.chargeQtyEleos();
            } else {
                this.saveActions();
            }
        },
        async editModeQtyBOL() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'Correction Details',
                message: 'Would you like to make a correction?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.chargeBOLEleos();
                this.chargeQtyEleos();
                this.ord.Display = false;
                this.edit = true;
                this.editBOL = true;
                this.ord.Edit = true;
                console.log('Check');
            } else {
                this.saveActions();
            }
        },
        showField: function(ord, field) {
            if (this.datesOrder) {
                ord[field] = true;
            }
        },
        getHrsUpdate: function() {
            var str = this.$store;
            // console.log('Hrs',this.OrderToCheck[this.pageOrders-1]);
            axios
                .get(
                    'order/separte/hrs/' +
                        this.OrderToCheck[this.pageOrders - 1]['OrderID']
                )
                .then(response => {
                    let dataorder = response.data[0];
                    this.OrderToCheck[this.pageOrders - 1]['TStart'] =
                        dataorder['TStart'];
                    this.OrderToCheck[this.pageOrders - 1]['TStartTime'] =
                        dataorder['TStartTime'];
                    this.OrderToCheck[this.pageOrders - 1]['TEnd'] =
                        dataorder['TEnd'];
                    this.OrderToCheck[this.pageOrders - 1]['TEndTime'] =
                        dataorder['TEndTime'];
                    this.OrderToCheck[this.pageOrders - 1]['StStart'] =
                        dataorder['StStart'];
                    this.OrderToCheck[this.pageOrders - 1]['StStartTime'] =
                        dataorder['StStartTime'];
                    this.OrderToCheck[this.pageOrders - 1]['StEnd'] =
                        dataorder['StEnd'];
                    this.OrderToCheck[this.pageOrders - 1]['StEndTime'] =
                        dataorder['StEndTime'];
                    //    console.log(this.OrderToCheck[this.pageOrders-1]);
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        cancelUpQty: function() {
            this.edit = false;
            this.ord.Edit = false;
        },
        getActions: function() {
            var str = this.$store;
            axios
                .get('action/active')
                .then(response => {
                    this.actions = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        sendToVerifiedOrders: async function(OrderID, eleos, display) {
            var str = this.$store;
            console.log('sendToVerifiedOrders');
            console.log(eleos, OrderID);
            if (display) {
                console.log(display);

                var parms = {
                    BolCheckStatusID: 1
                };
                if (eleos.length > 0) {
                    parms.BillOfLading = eleos[0].BOLNumber;
                }
                this.$store.state.isLoading = true;
                await axios
                    .put('order/' + OrderID, parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Order successfully updated.'
                        });
                        if (eleos.length > 0) {
                            this.UpdateQty(OrderID, eleos, 1);
                            var idx = await this.OrderToCheck.findIndex(x => {
                                return x.OrderID === OrderID;
                            });
                        }
                        console.log(idx, OrderID);
                        this.OrderToCheck[idx]['BolCheckStatusID'] = 1;
                        this.OrderToCheck[idx]['Status'] = 'success';
                        this.pageOrders++;
                        //   this.searchMissingGeofance('no Save');
                        str.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        str.state.isLoading = false;
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'Something is wrong. Please contact the administrator.'
                        });
                    });
            } else {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text:
                        'This option must not contain any actions to be selected'
                });
            }
        },
        chargeQtyEleos: async function() {
            console.log(this.ord.eleos_data);
            await this.ord['eleos_data'].forEach(x => {
                let idx = this.ord.order_details.findIndex(y => {
                    return y.OrderProdID == x.OrderProdID;
                });
                console.log(idx);
                this.ord.order_details[idx].DeliveredQuantity = x.GrossQuantity;
                this.ord.order_details[idx].TempAdjQuantity = x.NetQuantity;
            });
        },
        UpdateQty: async function(OrderID, qty, type) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Qty: qty,
                BolCheckStatusID: type,
                OrderID: OrderID,
                BillOfLading: this.bol == null ? this.bol_posted : this.bol
            };
            await axios
                .post('order-detail/order/eleos/update', parms)
                .then(async response => {
                    if (parms.BolCheckStatusID == 2) {
                        str.state.isLoading = false;
                        this.edit = false;
                        this.editBOL = false;
                        this.calculateTotals();
                    }
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        UpdatePosted4: async function(OrderID, qty, type) {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Qty: qty,
                BolCheckStatusID: type,
                OrderID: OrderID,
                BillOfLading: this.bol_posted
            };
            await axios
                .post('order-detail/order/eleos/update', parms)
                .then(async response => {
                    this.bol_posted = null;
                    str.state.isLoading = false;
                    this.calculateTotals();
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        editBOLData: function() {
            this.ord['order_details'].forEach(x => {
                x.BillOfLading = this.bol == null ? this.bol_posted : this.bol;
            });
        },
        updateDates: function(itm) {
            var str = this.$store;
            var parms = {
                DateDelivered: itm.DateDelivered,
                DateTerminalPick: itm.DateDelivered
            };
            axios
                .put('order/' + itm.OrderID, parms)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        sendToNotVerifiedOrders: async function(orderID) {
            var str = this.$store;
            console.log('sendToNotVerifiedOrders');
            console.log(orderID);

            this.$store.state.isLoading = true;
            await axios
                .put('paperwork-analytics/not-verified-order/' + orderID, '')
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Order successfully updated.'
                    });

                    if (this.FromEleosCheck) {
                        this.$emit('closeModal');
                        str.state.isLoading = false;
                    } else {
                        // Remove the order locally
                        str.state.isLoading = false;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                });
        },
        closePaperworkAnalyticsPanel: function() {
            // console.log("closePaperworkAnalyticsPanel");
            this.$emit('close');
            this.$emit('closeModal');
        },
        saveActions: function() {
            console.log('saveActions');
            this.searchMissingGeofance('saveAct');
        },
        openActionReasonModal: async function(
            orderID,
            BolCheckStatus,
            eleos_data
        ) {
            this.eleos_data = null;
            this.eleos_data = eleos_data;
            var idx = await this.OrderToCheck.findIndex(x => {
                return x.OrderID === orderID;
            });

            this.ord = this.OrderToCheck[idx];
            this.BolCheckStatus = BolCheckStatus;
            this.OrderID = orderID;
            this.$store.state.paperworkAnalytics.action = true;
        },
        calculateTotals: function() {
            this.ord.TotalDGQ = 0;
            this.ord.TotalDNQ = 0;
            this.ord.order_details.forEach(x => {
                this.ord.TotalDGQ += parseInt(x.DeliveredQuantity);
                this.ord.TotalDNQ += parseInt(x.TempAdjQuantity);
            });
        },
        chargeBOLEleos: async function() {
            console.log(this.ord.eleos_data[0].BOLNumber);
            this.ord['order_details'].forEach(x => {
                x.BillOfLading = this.ord.eleos_data[0].BOLNumber;
            });
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        checkDate: function(field) {
            console.log(this.getMsk(field), field);
            if (
                this.getMsk(field) == undefined ||
                this.getMsk(field) == null ||
                this.getMsk(field) == ''
            ) {
                return true;
            } else {
                switch (field) {
                    case 'TStart':
                        if (this.getMsk(field) < this.getMsk('TEnd')) {
                            return true;
                        }
                        break;
                    case 'TEnd':
                        if (this.getMsk(field) > this.getMsk('TStart')) {
                            // && this.getMsk(field) < this.getMsk('StStart')
                            return true;
                        }
                        break;
                    case 'StStart':
                        if (this.getMsk(field) > this.getMsk('TEnd')) {
                            // && this.getMsk(field) < this.getMsk('StEnd')
                            return true;
                        }
                        break;
                    case 'StEnd':
                        if (this.getMsk(field) > this.getMsk('StStart')) {
                            return true;
                        }
                        break;
                    default:
                        return false;
                }
            }
        },
        updateDatesOrder: async function(field, fieldOrg, order) {
            var str = this.$store;
            var parms = {};
            console.log(order);
            parms[field] = this.getMsk(field);
            parms[fieldOrg] = 3;
            console.log(parms);

            var message = await this.checkDate(field);
            console.log(message);
            if (message) {
                axios
                    .put('order/' + order['OrderID'], parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response.data);
                        if (
                            this.getMsk(field) == null ||
                            this.getMsk(field) == undefined ||
                            this.getMsk(field) == ''
                        ) {
                            order[field] = '';
                            order[field + 'Time'] = '';
                            order[fieldOrg] = 3;
                        } else {
                            order[field] = this.getMsk(field).split(' ')[0];
                            order[field + 'Time'] = this.getMsk(field).split(
                                ' '
                            )[1];
                            order[fieldOrg] = 3;
                        }
                    })
                    .catch(error => {
                        order.saving = false;
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        console.log(error);
                    });
            } else {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Wrong Dates'
                });
            }
        }
    }
};
</script>

<style scoped>
/* Styles here */
.v-dialog__content--active {
    background-color: transparent;
}

.v-dialog__content {
    opacity: 0.999;
}
</style>
